module.exports = function getResource(label) {
    const resources = {
        curbsideAvailable: 'Curbside Available',
        pickup: 'Pickup',
        sameDayDelivery: 'Same-Day Delivery'
    };
    return resources[label];
};
